import React from 'react';

const ContactBox = () => {
   
    return (
        <>
        <div className="contactBox">
        <a href="mailto:akshitrana21@gmail.com?subject=Hello Akshit!"><i className="fas fa-envelope"></i>
        <span>Contact me</span> 
        </a>
        </div>
        
       
    
        </>
    )
}

export default ContactBox;
